import { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const pin = (color) =>
  L.divIcon({
    className: "",
    html: `<div style="background:${color};width:18px;height:18px;border-radius:50% 50% 50% 0;transform:rotate(-45deg);border:2px solid #fff;box-shadow:0 1px 5px rgba(0,0,0,.45)"></div>`,
    iconSize: [18, 18],
    iconAnchor: [9, 18],
    popupAnchor: [0, -16],
  });

export function LiveMap({ markers = [], zoom = 13, height = 300 }) {
  const el = useRef(null);
  const map = useRef(null);
  const layer = useRef(null);

  useEffect(() => {
    if (!el.current || map.current) return;
    const first = markers.find((m) => m.lat != null && m.lng != null);
    const center = first ? [first.lat, first.lng] : [5.6037, -0.187];
    map.current = L.map(el.current, { zoomControl: true, attributionControl: false }).setView(center, zoom);
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", { maxZoom: 19 }).addTo(map.current);
    layer.current = L.layerGroup().addTo(map.current);
    return () => {
      map.current?.remove();
      map.current = null;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!map.current || !layer.current) return;
    layer.current.clearLayers();
    const pts = [];
    markers.forEach((m) => {
      if (m.lat == null || m.lng == null) return;
      const mk = L.marker([m.lat, m.lng], { icon: pin(m.color || "#2563eb") }).addTo(layer.current);
      if (m.label) mk.bindPopup(m.label);
      pts.push([m.lat, m.lng]);
    });
    if (pts.length === 1) map.current.setView(pts[0], zoom);
    else if (pts.length > 1) map.current.fitBounds(pts, { padding: [40, 40], maxZoom: 15 });
    setTimeout(() => map.current && map.current.invalidateSize(), 150);
  }, [markers, zoom]);

  return <div ref={el} data-testid="live-map" style={{ height, width: "100%", borderRadius: 12, zIndex: 0 }} />;
}
